import { useMemo, useState } from "react";

export const useSearchableList = <T extends { title: string }>(
  items: T[] | undefined,
  threshold: number = 8
) => {
  const shouldShowSearch = useMemo(() => {
    return (items?.length || 0) > threshold;
  }, [items, threshold]);

  const [searchTerm, setSearchTerm] = useState("");

  const filteredItems = useMemo(() => {
    if (!items) return [];
    if (!shouldShowSearch) return items;

    return items.filter((item) => item.title.toLowerCase().includes(searchTerm.toLowerCase()));
  }, [items, searchTerm, shouldShowSearch]);

  return {
    shouldShowSearch,
    searchTerm,
    setSearchTerm,
    filteredItems,
  };
};
